import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=7fffe928&scoped=true&"
import script from "./PageBase.vue?vue&type=script&lang=js&"
export * from "./PageBase.vue?vue&type=script&lang=js&"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=7fffe928&prod&lang=scss&scoped=true&"
import style1 from "./PageBase.vue?vue&type=style&index=1&id=7fffe928&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffe928",
  null
  
)

export default component.exports